import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/athena-logo-white.png';
import '../styles/HomePage.css';

const Header: React.FC = () => {
  return (
    <header>
      <div className='header-content'>
        <div className='logo'>
          <img src={logo} alt='Athena Logo' />
        </div>
        <nav>
          <ul>
            <li>
              <Link
                to='/request-account'
                className='request-account'
                target='_blank'
              >
                Request Account
              </Link>
            </li>
            <li>
              <a
                href='./assets/Athena4P_FAQ_25SEP2023.pdf'
                className='faq'
                target='_blank'
                rel='noopener noreferrer'
              >
                FAQ
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
